import React from "react";
import { FieldType, ValidationRules } from "../../../types/documentTypes";
import Input from "@mui/joy/Input";
import Box from "@mui/joy/Box";
import DateInput from "../../common/DateInput";

interface FieldValidationControlsProps {
  type: FieldType;
  validation?: ValidationRules;
  onChange: (validation: ValidationRules) => void;
}

const FieldValidationControls: React.FC<FieldValidationControlsProps> = ({
  type,
  validation = {},
  onChange,
}) => {
  const handleChange = (updates: Partial<ValidationRules>) => {
    onChange({ ...validation, ...updates });
  };

  return (
    <Box sx={{ padding: 1 }}>
      {type === "Text" && (
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "repeat(3, 1fr)" },
            gap: 1,
          }}
        >
          <Input
            type="number"
            value={validation.minLength || ""}
            onChange={(e) =>
              handleChange({
                minLength: e.target.value ? Number(e.target.value) : undefined,
              })
            }
            placeholder="Min Length"
            size="sm"
          />
          <Input
            type="number"
            value={validation.maxLength || ""}
            onChange={(e) =>
              handleChange({
                maxLength: e.target.value ? Number(e.target.value) : undefined,
              })
            }
            placeholder="Max Length"
            size="sm"
          />
          <Input
            type="text"
            value={validation.pattern || ""}
            onChange={(e) =>
              handleChange({ pattern: e.target.value || undefined })
            }
            placeholder="Regex Pattern"
            size="sm"
          />
        </Box>
      )}

      {type === "Number" && (
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "repeat(2, 1fr)" },
            gap: 1,
          }}
        >
          <Input
            type="number"
            value={(validation.min as number) || ""}
            onChange={(e) =>
              handleChange({
                min: e.target.value ? Number(e.target.value) : undefined,
              })
            }
            placeholder="Min Value"
            size="sm"
          />
          <Input
            type="number"
            value={(validation.max as number) || ""}
            onChange={(e) =>
              handleChange({
                max: e.target.value ? Number(e.target.value) : undefined,
              })
            }
            placeholder="Max Value"
            size="sm"
          />
        </Box>
      )}

      {type === "Date" && (
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "repeat(2, 1fr)" },
            gap: 1,
          }}
        >
          <DateInput
            value={(validation.min as string) || ""}
            onChange={(value) => handleChange({ min: value || undefined })}
            size="sm"
          />
          <DateInput
            value={(validation.max as string) || ""}
            onChange={(value) => handleChange({ max: value || undefined })}
            size="sm"
          />
        </Box>
      )}
    </Box>
  );
};

export default FieldValidationControls;
